"use client";

import { ChevronDown, MapPin, Navigation } from "lucide-react";

/**
 * Botão "Como chegar" da página de links.
 *
 * Usa `<details>` nativo em vez de um dropdown controlado por JavaScript. No
 * celular, o toque abre as opções mesmo antes da hidratação — e continua
 * funcionando se o JavaScript falhar.
 */
export function BotaoComoChegar({
  googleMapsUrl,
  wazeUrl,
  atraso = 0,
}: {
  googleMapsUrl: string;
  wazeUrl: string;
  atraso?: number;
}) {
  function fechar(evento: React.MouseEvent<HTMLAnchorElement>) {
    evento.currentTarget.closest("details")?.removeAttribute("open");
  }

  return (
    <details
      className="group relative z-40 motion-safe:animate-fade-up motion-reduce:animate-none"
      style={{ animationDelay: `${atraso}s` }}
    >
      <summary
        aria-controls="menu-como-chegar"
        className="flex w-full cursor-pointer list-none items-center gap-3 rounded-xl border border-paper-border/80 bg-white/80 p-2.5 text-left shadow-[0_18px_38px_-24px_rgba(16,26,51,0.45)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-gold/40 hover:bg-white hover:shadow-[0_26px_55px_-24px_rgba(130,103,50,0.55)] [&::-webkit-details-marker]:hidden"
      >
        <span className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-royal to-navy text-paper shadow-sm">
          <MapPin className="size-5" aria-hidden />
        </span>

        <span className="min-w-0 flex-1">
          <span className="block text-sm font-semibold text-ink">Como chegar</span>
          <span className="mt-0.5 block truncate text-xs text-ink-muted">
            Escolha o aplicativo
          </span>
        </span>

        <ChevronDown className="seta size-4 shrink-0 text-gold" aria-hidden />
      </summary>

      <div
        id="menu-como-chegar"
        className="absolute right-0 top-full z-50 mt-2 w-52 overflow-hidden rounded-xl border border-paper-border/80 bg-white p-1 shadow-xl"
      >
        <a
          href={googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={fechar}
          className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-ink transition-colors hover:bg-paper-soft"
        >
          <MapPin className="size-4 text-[#EA4335]" aria-hidden />
          Google Maps
        </a>

        <a
          href={wazeUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={fechar}
          className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-ink transition-colors hover:bg-paper-soft"
        >
          <Navigation className="size-4 text-[#33CCFF]" aria-hidden />
          Waze
        </a>
      </div>
    </details>
  );
}
